export default __webpack_public_path__ + "static/media/communication_intro.0c6d686f.jpg";